import { delMany } from 'idb-keyval';

const restartProspectus = (isSavedRestart) => async (dispatch) => {
	// Delete the application data.
	delMany(['sections', 'activeSections', 'inActiveSections'])
		.then(() => console.log('Restart'))
		.catch((err) => console.log('It failed!', err));

	// set the user url to /
	if (isSavedRestart) {
		window.location.href = '/personalise?refresh=true&isSaved=true';
	} else {
		window.location.href = '/personalise?refresh=true';
	}
};

export default restartProspectus;
